import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { formatApiError } from "@/lib/utils2";
import { ALL_CLASSES } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Loader2 } from "lucide-react";

export const EnquiryForm = ({ compact }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", student_class: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Please enter your name and phone number.");
      return;
    }
    setLoading(true);
    try {
      await api.createEnquiry(form);
      toast.success("Thank you! Our team will contact you shortly.");
      setForm({ name: "", phone: "", email: "", student_class: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Failed to submit.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="enquiry-form">
      <Input data-testid="enquiry-name" placeholder="Parent / Student Name *" value={form.name} onChange={(e) => set("name", e.target.value)} />
      <Input data-testid="enquiry-phone" placeholder="Phone Number *" value={form.phone} onChange={(e) => set("phone", e.target.value)} />
      {!compact && (
        <Input data-testid="enquiry-email" type="email" placeholder="Email (optional)" value={form.email} onChange={(e) => set("email", e.target.value)} />
      )}
      <Select value={form.student_class} onValueChange={(v) => set("student_class", v)}>
        <SelectTrigger data-testid="enquiry-class"><SelectValue placeholder="Class of Interest" /></SelectTrigger>
        <SelectContent>
          {ALL_CLASSES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
        </SelectContent>
      </Select>
      <Textarea data-testid="enquiry-message" placeholder="Your message (optional)" rows={compact ? 2 : 3} value={form.message} onChange={(e) => set("message", e.target.value)} />
      <Button type="submit" disabled={loading} data-testid="enquiry-submit" className="w-full bg-brandred hover:bg-brandred/90 text-white font-semibold rounded-full">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Submit Enquiry"}
      </Button>
    </form>
  );
};
